import { useEffect, useState } from "react";
import "./App.css";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Interview from "./Components/Interview";
import Product from "./Components/Product";

const App = () => {
  const [websiteData, setWebsiteData] = useState({});

  useEffect(() => {
    fetch("./data.json")
      .then(response => {
        if (!response.ok) throw new Error("Unable to load website data");
        return response.json();
      })
      .then(data => {
        setWebsiteData(data);
        document.title = data.siteMetadata.pageTitle;
        document.querySelector('meta[name="description"]')?.setAttribute("content", data.siteMetadata.pageDescription);
      })
      .catch(error => console.error(error));
  }, []);

  return (
    <div className="App">
      <Header navigation={websiteData.navigation} content={websiteData.welcomeSection} />
      <main id="main-content">
        <Product data={websiteData.productSection} />
        <Interview data={websiteData.interviewSection} />
      </main>
      <Footer data={websiteData.footer} />
    </div>
  );
};

export default App;
